import React from 'react';
import { useSelector } from 'react-redux';
import Time from '../time/Time';
import TimeFormatter from '../time/TimeFormatter';
import { getReissueDisplayInfo } from '../../../../store/helpers';

function TicketDetails({ ticket }) {
    const { services } = useSelector(state => state.services);
    const { tickets } = useSelector(state => state.tickets);

    if (!services.length) {
        return (
            <div>
                <div className="informationContainer informationEmpty">
                    <p>Loading services</p>
                </div>
            </div>
        );
    }
    if (ticket == null) {
        return (
            <div>
                <div className="informationContainer informationEmpty">
                    <p>No tickets available</p>
                </div>
            </div>
        );
    }

    const service = services.find(data => data.id === ticket.serviceId);
    const serviceName = service != null ? service.name : null;
    const slaBreach = ticket.slaBreach;
    const activeServiceMinutes = slaBreach
        ? slaBreach.activeServiceMinutes || Math.ceil((Number(slaBreach.activeServiceSeconds) || 0) / 60)
        : 0;
    const thresholdMinutes = slaBreach
        ? slaBreach.thresholdMinutes || Math.ceil((Number(slaBreach.thresholdSeconds) || 0) / 60)
        : 0;
    const overMinutes = slaBreach
        ? Math.max(0, activeServiceMinutes - thresholdMinutes)
        : 0;
    const isActiveServiceBreach = Number(ticket.status) === 1
        && ticket.slaBreached
        && slaBreach
        && slaBreach.breachType === 'active-service-time';
    const reissueInfo = getReissueDisplayInfo(ticket, tickets);
    const isReissuedTicket = Boolean(reissueInfo);
    const queueCreated = reissueInfo ? reissueInfo.originalCreated : Number(ticket.created);

    return (
        <div>
            <div className={`informationContainer ${isActiveServiceBreach ? 'informationContainerWithSlaStatus' : ''}`}>
                {
                    isReissuedTicket
                        ?   <div className="informationRow reissueTicketNotice">
                                <label>Ticket Type</label>
                                <span>Re-assigned Ticket</span>
                            </div>
                        :   null
                }
                <div className="informationRow">
                    <label>Ticket Number</label>
                    <span>{ticket.ticketLetter}{ticket.ticketNumber}</span>
                </div>
                {
                    isReissuedTicket
                        ?   <div className="informationRow">
                                <label>Re-assigned From</label>
                                <span>{reissueInfo.reissuedFromLabel}</span>
                            </div>
                        :   null
                }
                {
                    isReissuedTicket
                        ?   <div className="informationRow">
                                <label>Original Ticket</label>
                                <span>{reissueInfo.originalTicketLabel}</span>
                            </div>
                        :   null
                }
                <div className="informationRow">
                    <label>Service</label>
                    <span>{serviceName}</span>
                </div>
                <div className="informationRow">
                    <label>Total In-branch Time</label>
                    <span><Time created={queueCreated} /></span>
                </div>
                <div className="informationRow">
                    <label>{isReissuedTicket ? 'Original Arrival Time' : 'Customer Arrival Time'}</label>
                    <span><TimeFormatter created={queueCreated} /></span>
                </div>
                {
                    isActiveServiceBreach
                        ?   <div className="informationRow slaStatusRow">
                                <label>SLA Status</label>
                                <span>
                                    Service SLA breached
                                    <small>Active {activeServiceMinutes} min. SLA limit {thresholdMinutes} min. Over by {overMinutes} min.</small>
                                </span>
                            </div>
                        :   null
                }
            </div>
        </div>
    );
}

export default TicketDetails;
